import React, { useState, useEffect, useRef} from "react"

//Components
import Deflator from "./Deflator"
import RadioGroup from "./RadioGroup"
import ShockSelector from "./ShockSelector"
import InputGroup from "./InputGroup"
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress'
import Button from '@material-ui/core/Button';

import "./ModalDialog.scss"
//Static Data
import navigation from "../../data/navigation.json"

export default function ModalDialog(props) {
  const {model, type, setRefresh, currentScenario, setCurrentScenario, trigger, setTrigger} = props

  //Scenario Items
  const [title, setTitle] = useState()
  const [gdp, setGdp] = useState({year: 2014, value: 1, customValue: 0})
  const [custom, setCustom] = useState(false)
  const [shocks, setShocks] = useState([])
  const [loading, setLoading] = useState(false)

  //Modal Dialog reference "box"
  let modalRef = useRef()


  //Functions
  const resetScenario = () => {
    // clearing the values
    if(type == 'create') {
      setTitle("");
    }
    setCustom(false)
    setGdp({year: 2014, value: 1, customValue: 0})
    setShocks([])

    switch(model) {
        case "Species":
            Window.vms.clearInputs();
            break

        case "Gear":
            Window.vmg.clearInputs();
            break;

        case "Charter":
            Window.vmc.clearInputs();
            break

        default:
            break
    }
  }

  const setScenario = () => {
    setTitle(currentScenario)
    switch(model) {
      case "Species":
          setGdp({year: Window.vms.selectedDeflator().year, value: Window.vms.selectedDeflator().deflator, customValue: Window.vms.customDeflator()})
          if (Window.vms.customDeflator() === 0) {
            setCustom(false)
          } else {
            setCustom(true)
          }
          break

      case "Gear":
        setGdp({year: Window.vmg.selectedDeflator().year, value: Window.vmg.selectedDeflator().deflator, customValue: Window.vmg.customDeflator()})
        if (Window.vmg.customDeflator() === 0) {
          setCustom(false)
        } else {
          setCustom(true)
        }
        break

      case "Charter":
        setGdp({year: Window.vmc.selectedDeflator().year, value: Window.vmc.selectedDeflator().deflator, customValue: Window.vmc.customDeflator()})
        if (Window.vmc.customDeflator() === 0) {
          setCustom(false)
        } else {
          setCustom(true)
        }
        break

      default:
          break
    }
  }

  const cancelScenario = () => {
    Window.loadScenario(currentScenario, model)
    setShocks([])
    setRefresh(true)
    setTrigger({...trigger, display: false})
  }

  const createScenario = () => {
    if (title !== "") {
      
      if (Window.checkScenario(title, model)){
        Window.saveScenario(title, model)
        // Window.loadScenario(title, model)
        setCurrentScenario(title)
        setRefresh(true)
        setTrigger({...trigger, display: false})
      } else {
        alert("This scenario name already exists")
      }

    } else {
      alert("Scenario name must be filled")
    }
  }

  const saveScenario = () => {
    Window.saveScenario(currentScenario, model)
    setTrigger({...trigger, display: false})
  }

  const deleteScenario = () => {
    setCurrentScenario("Default Scenario")
    Window.removeScenario(title, model)
    setRefresh(true)
    setTrigger({...trigger, display: false})
  }


  useEffect(() => {

    setLoading(true)
    setTimeout(() => {setLoading(false)}, 500);

    if (type == 'create'){
      resetScenario()
    } else {
      setScenario()
    }

  },[type])


  return (
      <div className={trigger ? "ModalDialog" : "ModalDialog_hidden"}>
        <div className="ModalDialogContainer">
          <form ref={modalRef} className={loading ? "ModalDialogInner_loading" : "ModalDialogInner"}>
            <div className="Titlebar">
              <TextField id="ScenarioTitle" autoComplete="off" value={title} className={type == 'create' ? "ScenarioTitle" : "title_hidden"} inputProps={{ maxLength: 25 }} id="standard-basic" label="Scenario name"
                onChange={e => setTitle(e.target.value)}/>
              <h1 className={type == 'edit' ? "ScenarioTitleHeader" : "title_hidden"}>{title}</h1>
            </div>
            <div className="ModalDialogInputs">
              <Deflator model={model} 
                        items={navigation[0].items} 
                        gdp={gdp} 
                        setGdp={setGdp}
                        custom={custom}
                        setCustom={setCustom} />
              <div className="ModalDialogShocks">
                <ShockSelector model={model} shocks={shocks} setShocks={setShocks} items={navigation[2].data} />
                {/* <RadioGroup model={model} items={navigation[1].items} radio={radio} setRadio={setRadio}/> */}
                <InputGroup />
              </div>
            </div>
            <div className="ModalDialogButtons">
              <div className="LeftButtons">
                <Button variant="contained" onClick={cancelScenario}>Cancel</Button>
                <Button variant="contained" onClick={resetScenario}>Reset Scenario</Button>
              </div>
              <div className="RightButtons">
                {/* <Button variant="contained" onClick={saveScenario}>Save</Button> */}
                {/* <Button variant="contained">Save</Button> */}
                <Button variant="contained" className={type == 'create' || currentScenario == 'Default Scenario' ? 'button_hidden' : 'RemoveButton'} onClick={deleteScenario}>Delete Scenario</Button>
                <Button variant="contained" className={type == 'edit' ? 'SaveButton' : 'button_hidden'} onClick={saveScenario}>Save</Button>
                <Button variant="contained" className={type == 'create' ? 'CreateButton' : 'button_hidden'} onClick={createScenario}>Create</Button>
              </div>
            </div>
          </form>
          
          <div className={loading ? "loading" : "loading_hidden"}>
            <CircularProgress />
          </div>
        </div>
    </div> 
  )
}
